module.exports = __webpack_public_path__ + "static/img/top-bg.f58ada6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top-bg.jpg
// module id = 516
// module chunks = 1